import React, { Component } from "react";
import { RequestHeaders } from "../../../common/header-logo/request-header.component";
import { HeaderFilter } from "../../../common/header-filter/header-filter.component";
import { DataTable } from "../../../common/table/data-table/data-table-component";
import { httpGet } from "../../../../utils/api.utils";
import ContractDetails from "./details/detail.component";
import "../finance.component.css";
import { Header_Filter_Button_Label } from "../../../../constants/internal-constants";
export class Contract extends Component {
    constructor(props) {
        super(props);
        this.state = {
            pageNumber: 1,
            contractDataItem: [],
            requestDetails: false,
            viewDetailPage:false
        }
    }
    // componentDidMount() {
    //     this.getContractsDetails(this.state.pageNumber);
    // }
    // componentDidUpdate(prevProps, prevState) {
    //     if (prevState.pageNumber !== this.state.pageNumber) {
    //         this.setState({requestDetails: false})
    //         this.getContractsDetails(this.state.pageNumber);
    //     }

    // }
    // updatePageNumber = (page) => {
    //     this.setState({pageNumber: page})
    // }
    // getContractsDetails = async (pageNumber) => {
    //     this.setState({ activePage: pageNumber });
    //     var that = this;
    //     const dealName = window.sessionStorage.getItem('DealName')
    //     var getContractsData = await httpGet(`finance/${dealName}/contract/getContractSearch?searchVal=null&filterType=Contract Name&pageNumber=${pageNumber}`)
    //     const countContracts = await httpGet(`finance/${dealName}/contractCount?searchVal=null&filterType=Contract Name&pageNumber=${pageNumber}`)
    //     var userID = window.sessionStorage.getItem("UserID");
    //     const newContractData = getContractsData?.map((item) => (
    //         {
    //             ContractName: item.ContractName,
    //             Vendor: item.Vendor,
    //             Status: item.Status,
    //             ServiceType: item.Service_Type,
    //             EffectiveDate: item.EffectiveDate,
    //             ExpirationDate: item.ExpirationDate
    //         }))

    //     this.setState({ contractDataItem: [...newContractData] });
    //     if (this.state.contractDataItem.length > 0) {
    //         this.setState({ requestDetails: true})
    //     }
    //     //url = Utilities.getAPIHttps() + "finance/" + this.props.dealName + "/contract/getContractSearch?searchVal=" + this.state.handleSearchValue + "&filterType=" + this.state.contractSearchBy + "&pageNumber=" + pageNumber;
    //     //fetch(url.url, {
    //     //    method: "GET",
    //     //    // headers: {
    //     //    //     'Accept': 'application/json',
    //     //    //     'Content-Type': 'application/json'
    //     //    // },
    //     //   /* headers: Utilities.GetAjaxHeader(),*/
    //     //}).then(function (res) {
    //     //    console.log('res', res)
    //     //    return res.json();
    //     //}).then(function (data) {
    //     //    if (that.state.searchValue != null) {
    //     //        if (data.length > 0) {
    //     //            that.getSearchedDetails();
    //     //            that.setState({
    //     //                contracts: data,
    //     //                showEmptyResult: false
    //     //            });
    //     //        }
    //     //        else {
    //     //            that.setState({
    //     //                contracts: data,
    //     //                showModal: true,
    //     //                /*  modalMessage: <Translation translationKey={"zero_result_found"} />,*/
    //     //                modalMessage: "zero_result_found",
    //     //                pageCount: 0
    //     //            });
    //     //        }
    //     //    } else {
    //     //        that.setState({
    //     //            contracts: data,
    //     //            pageCount: 0
    //     //        })
    //     //    }
    //     //});
    // }
    getData=(value)=>{
		this.setState({viewDetailPage:value})
	  }
    render() {
        const dropdownItem = ["Item 1", "Item 2", "Item 3"]
        const dataTable = [
            {
                HeaderItem: [
                    {
                        name: "Contract Name"
                    },
                    {
                        name: "Vendor"
                    }, {
                        name: "Status"
                    }, {
                        name: "Service Type"
                    }, {
                        name: "Effective Date"
                    }, {
                        name: "Expiration Date"
                    }
                ],
                dataItem: this.state.contractDataItem

            }
        ]
        const pages = {
            HasNext: true,
            HasPrevious: false,
            PageNumber: 0,
            PerPage: 21,
            TotalEntries: 2453,
            TotalPages: 123

        }
        const listItem = [
            {
                listTitle: "Plan",
                href: "#"
            }
            , {
                listTitle: "Feature"
                , href: "#"
            }
            , {
                listTitle: "Rate"
                , href: "#"
            }
        ];
        return (
            <>
                <RequestHeaders headerTitle="Contract" />
                {this.state.viewDetailPage ? 
                    <ContractDetails closeForm={this.getData.bind(this)} />
                    :
                    <div className="request-table data-table internal-data-table">
                        <HeaderFilter enableDropdown={true} dropdownItem={dropdownItem} enableExportExcel={false} btnAddTitle={Header_Filter_Button_Label.AddContract} enableAddBtn={true} enableUploadBtn={false} listItem={listItem} haveTab={false} />
                    </div>
                }                
            </>
        )
    }
}